/** Staging apps share this flag. Change it and redeploy to switch networks. */
export const STAGING_DEVNET = true;

/** USDv on Devnet. Keep in sync with network-plugin.mjs and yaas-api's DEVNET_USDV_MINT. */
export const DEVNET_USDV_MINT = "Wdek6QzQzHoT822HLPUHWowYrRHUcX4w5CRfRYQ5fh2";

/**
 * Solomon's Helius Devnet endpoint for browsers. It is public (it ships in bundles),
 * and netlify.toml's connect-src allows it. The public Solana Devnet RPC rate-limits
 * apps that read many balances. Keep in sync with network-plugin.mjs.
 */
export const DEVNET_BROWSER_RPC_URL = "https://arlana-lt1k86-fast-devnet.helius-rpc.com";
